import { useEffect } from 'react';
import { aplicarAparencia, useAparencia } from '../lib/aparencia';

/**
 * Sincroniza a preferência de aparência com o `<html>` em runtime.
 *
 * O PRIMEIRO paint já vem correto pelo script anti-FOUC do `index.html`; este
 * componente cuida das mudanças feitas depois — o clique no painel e o sistema
 * operacional escurecendo sozinho no fim da tarde.
 *
 * Não renderiza nada.
 */
export function AparenciaSync() {
  const tema = useAparencia((a) => a.tema);
  const matiz = useAparencia((a) => a.matiz);
  const fonte = useAparencia((a) => a.fonte);
  const densidade = useAparencia((a) => a.densidade);
  const cantos = useAparencia((a) => a.cantos);
  const altoContraste = useAparencia((a) => a.altoContraste);
  const menosMovimento = useAparencia((a) => a.menosMovimento);

  useEffect(() => {
    const estado = {
      tema,
      matiz,
      fonte,
      densidade,
      cantos,
      altoContraste,
      menosMovimento,
    };
    aplicarAparencia(estado);

    if (tema !== 'automatico') return;

    // Em "automático" o tema tem de reagir enquanto a pessoa usa: o sistema
    // pode virar para escuro no meio do expediente.
    const consulta = window.matchMedia('(prefers-color-scheme: dark)');
    const aoMudar = () => aplicarAparencia(estado);
    consulta.addEventListener('change', aoMudar);
    return () => consulta.removeEventListener('change', aoMudar);
  }, [tema, matiz, fonte, densidade, cantos, altoContraste, menosMovimento]);

  return null;
}
